import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './License.css';
import license from '../docs/LICENSE.md';

const License = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    // Fetch the Markdown content from the license file
    fetch(license)
      .then((res) => res.text())
      .then((text) => setMarkdown(text))
      .catch((error) => console.error('Error loading license markdown:', error));
  }, []);

  return (
    <div className="license-content ">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
};

export default License;
